module.exports = __webpack_public_path__ + "img/dialog-icon2.0dbd90b7.svg";